<template>
  <base-wrapper :loading="loadingSupplier || form.loading || deleteConfirm.loading || moveProductModal.loading || loadingJobStatus">
    <div class="space-y-4">
      <div class="flex items-center justify-end space-x-2">
        <base-input
          type="search"
          placeholder="Cari Volume"
          debounce
          :shadow="false"
          v-model="filter.search"
          @native-input="loadUnits"
        />
        <base-button @click="onCreate" type="button">
          <Icon icon="heroicons:plus-20-solid" class="h-5 w-5" />
          Tambah Volume
        </base-button>
        <base-button :loading="loadingExport.visible" @click="onExport">
          <Icon
            v-if="!loadingExport.visible"
            icon="heroicons:arrow-down-tray"
            class="h-4 w-4"
          />
          {{ loadingExport.visible ? loadingExport.text : 'Export' }}
        </base-button>
      </div>
      <datatable
        :total="units.meta.page.total"
        :perPage="units.meta.page.perPage"
        :currentPage="units.meta.page.currentPage"
        :columns="[
          { id: 'name', name: 'Volume' },
          { id: 'action', name: 'Aksi' },
        ]"
        @pagechanged="onPageChange"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="unit in units.data"
            :key="unit.id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="classes.td">{{ unit.attributes.name }}</td>
            <td :class="[classes.td]">
              <div class="flex gap-1">
                <button
                  class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                  @click="onEdit(unit)"
                >
                  <Icon icon="heroicons:pencil-square-solid" class="w-4 h-4" />
                </button>
                <button
                  v-if="!unit.attributes.has_products"
                  class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                  @click="onDelete(unit)"
                >
                  <Icon icon="heroicons:trash-solid" class="w-4 h-4" />
                </button>
                <button
                  v-else
                  class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                  @click="onMoveProduct(unit)"
                >
                  <Icon icon="heroicons:inbox-arrow-down-solid" class="w-4 h-4" />
                </button>
              </div>
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <base-modal
      :showing="form.visible"
      @close="form.visible = false"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div>
            <h3 class="text-lg font-bold leading-6 text-gray-900">
              {{ form.type === 'create' ? 'Tambah Volume' : 'Edit Volume' }}
            </h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              {{ form.type === 'create' ? 'Tambah Volume Baru' : 'Edit Volume' }}
            </p>
          </div>
        </div>
      </div>
      <form
        class="mt-6 space-y-4 border-t border-gray-200 pt-6"
        @submit.prevent="onSubmitForm"
      >
        <base-input
          label="Nama Volume"
          :shadow="false"
          fullwidth
          placeholder="Nama Volume"
          type="text"
          required
          v-model="form.name"
        />
        <div class="space-x-2">
          <base-button color="white" type="button" @click="form.visible = false"
            >Batal</base-button
          >
          <base-button>Simpan</base-button>
        </div>
      </form>
    </base-modal>

    <base-confirm
      :visible="moveProductModal.visible"
      type="success"
      title="Pindah Produk"
      message="Pindah produk ke volume lain."
      icon-type="badge"
      confirm-text="Pindah"
      @close="moveProductModal.visible = false"
      @confirmed="onConfirmMove"
    >
      <template #content>
        <BaseSelect expand :shadow="false" :options="moveOptions" v-model="moveProductModal.moveId"></BaseSelect>
      </template>
    </base-confirm>

    <base-confirm
      :visible="deleteConfirm.visible"
      title="Hapus Volume"
      message="Apakah anda yakin ingin menghapus volume ini?"
      icon-type="badge"
      @close="deleteConfirm.visible = false"
      @confirmed="onConfirmDelete"
    />
  </base-wrapper>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import { requestMixin } from '@/mixins/request/request';
import BaseModal from '../../../../../../components/base/BaseModal.vue';
import { mapActions } from 'vuex';
import BaseConfirm from '../../../../../../components/base/BaseConfirm.vue';
import { mapGetters } from 'vuex';
import { downloadFileUrl } from '../../../../../../services/utils.service';

export default {
  name: 'Home',
  mixins: [requestMixin],
  components: {
    BaseButton,
    BaseModal,
    BaseConfirm
  },
  data() {
    return {
      filter: {
        search: null,
      },
      loadingSupplier: false,
      units: {
        data: [],
        meta: {
          page: {},
        },
      },
      allUnits: {
        data: [],
        meta: {
          page: {},
        },
      },
      form: {
        visible: false,
        loading: false,
        type: 'create',
        name: null,
        editId: null
      },
      deleteConfirm: {
        visible: false,
        loading: false,
        id: null
      },
      moveProductModal: {
        visible: false,
        unitId: null,
        moveId: null,
        loading: false
      },
      loadingJobStatus: false,
      loadingExport: {
        visible: false,
        text: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      getChannelName: 'auth/getChannelName',
    }),
    moveOptions() {
      return [
        {
          key: null,
          value: null,
          label: 'Pilih Satuan Volume',
        },
        ...this.allUnits.data.map((unit) => ({
          key: unit.id,
          value: unit.id,
          label: unit.attributes.name,
        })),
      ];
    },
  },
  created() {
    this.loadUnits();
    this.loadAllUnits();
    this.loadJobStatus();
    this.addListener()
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    onPageChange(page) {
      this.loadUnits({
        'page[number]': page
      });
    },
    onCreate() {
      this.form.type = 'create'
      this.form.name = null
      this.form.editId = null
      this.form.visible = true;
    },
    onEdit(unit) {
      this.form.type = 'edit'
      this.form.name = unit.attributes.name
      this.form.editId = unit.id
      this.form.visible = true;
    },
    onMoveProduct(unit) {
      this.moveProductModal.unitId = unit.id
      this.moveProductModal.moveId = null
      this.moveProductModal.visible = true;
    },
    onDelete(unit) {
      this.deleteConfirm.id = unit.id
      this.deleteConfirm.visible = true
    },
    async onConfirmDelete() {
      this.deleteConfirm.loading = true;

      const [, error] = await this.request(`/api/v1/units/${this.deleteConfirm.id}`, {
        method: 'delete'
      });

      if (!error) {
        this.deleteConfirm.visible = false;
        this.loadUnits();
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.deleteConfirm.loading = false;
    },
    async onConfirmMove() {
      this.moveProductModal.loading = true;

      const [, error] = await this.request(`/api/v1/units/${this.moveProductModal.unitId}/-actions/move-product`, {
        method: 'post',
        data: {
          move_id: this.moveProductModal.moveId
        }
      });

      if (!error) {
        this.moveProductModal.visible = false;

        this.createAlert({
          data: 'Produk berhasil dipindahkan',
          status: 'success',
        });
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.moveProductModal.loading = false;
    },
    async onSubmitForm() {
      this.form.loading = true;

      const [, error] = await this.request(this.form.type === 'create' ? '/api/v1/units' : `/api/v1/units/${this.form.editId}`, {
        method: this.form.type === 'create' ? 'post' : 'patch',
        data: {
          data: {
            type: 'units',
            ...(this.form.type === 'create' ? {} : { id: this.form.editId }),
            attributes: {
              name: this.form.name,
              unit_type: 'volume',
            },
          },
        },
      });

      if (!error) {
        this.form.visible = false;
        this.loadUnits();
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.form.loading = false;
    },
    async onExport() {
      this.startLoadingExport('Mengirim ke server');

      const [, err] = await this.request(
        `/api/v1/units/-actions/export`,
        {
          method: 'post',
          data: {
            export_type: 'volume'
          }
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });

        this.stopLoadingExport();
      } else {
        this.startLoadingExport('Sedang diproses');
      }
    },
    onExportProgress(e) {
      if (e.type === 'App\\Notifications\\UnitExported' && e.unit_type === 'volume') {
        if (e.status === 'failed') {
          this.stopLoadingExport();

          this.createAlert({
            data: 'Gagal mengexport volume',
            status: 'error',
          });
        } else if (e.status === 'success') {
          this.stopLoadingExport();

          downloadFileUrl(e.file_url, 'volume.csv', { blank: true });
        }
      }
    },
    addListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onExportProgress
      );
    },
    async loadUnits(params) {
      this.loadingSupplier = true;

      const [res, err] = await this.request('/api/v1/units', {
        params: {
          'page[size]': 5,
          'filter[search]': this.filter.search,
          'filter[unit_type]': 'volume',
          'sort': 'name',
          ...params,
        },
      });

      if (!err) {
        this.units = res;
      }

      this.loadingSupplier = false;
    },
    async loadAllUnits() {
      const [res, err] = await this.request('/api/v1/units', {
        params: {
          'filter[unit_type]': 'volume',
        },
      });

      if (!err) {
        this.allUnits = res;
      }
    },
    async loadJobStatus() {
      this.loadingJobStatus = true;

      const [res, err] = await this.request(
        '/api/v1/users/-actions/check-job-status',
        {
          params: {
            type: 'export_volume',
          },
        }
      );

      if (!err) {
        const { running } = res;

        if (running) {
          this.startLoadingExport('Sedang Diproses');
        }
      }

      this.loadingJobStatus = false;
    },
    startLoadingExport(text) {
      this.loadingExport.text = text;
      this.loadingExport.visible = true;
    },
    stopLoadingExport() {
      this.loadingExport.visible = false;
    },
    removeExportListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      if (userChannel) {
        userChannel.unbind(
          'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
          this.onExportProgress
        );
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.removeExportListener();

    next();
  },
};
</script>
